import { render, staticRenderFns } from "./WeekOverview.vue?vue&type=template&id=c5809b68&scoped=true&"
import script from "./WeekOverview.vue?vue&type=script&lang=js&"
export * from "./WeekOverview.vue?vue&type=script&lang=js&"
import style0 from "./WeekOverview.vue?vue&type=style&index=0&id=c5809b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5809b68",
  null
  
)

export default component.exports